import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ALPHA, MOTION } from "../../theme/tokens";
import SystemButton from "../UIToolkit/SystemButton/SystemButton";

type Props = {
	open: boolean;
	onToggle: () => void;
	/** The ids of the composition regions it folds, for `aria-controls`. */
	controls: string;
};

/** Folds and unfolds every segment's rule lines. Screen-only: print always folds them. */
export const CompositionToggle: FC<Props> = ({ open, onToggle, controls }) => {
	const { t } = useTranslation();
	return (
		<SystemButton
			buttonVariant="borderless"
			size="compact"
			noFullWidthMobile
			onClick={onToggle}
			aria-expanded={open}
			aria-controls={controls}
			data-testid="wage-breakdown-composition-toggle"
			leadingIcon={
				<KeyboardArrowDownRoundedIcon
					sx={{
						transition: `transform ${MOTION.DURATION.CONTROL}ms ${MOTION.EASE_OUT}`,
						transform: open ? "rotate(180deg)" : "none",
						"@media (prefers-reduced-motion: reduce)": { transition: "none" },
					}}
				/>
			}
			// Transparent on the washed band (the borderless default is a white fill); a brand tint on hover.
			sx={(theme) => ({
				mt: 0.75,
				ml: -1.25,
				color: theme.palette.primary.main,
				backgroundColor: "transparent",
				"&:hover": { backgroundColor: alpha(theme.palette.primary.main, ALPHA.SELECTED_OVERLAY) },
				displayPrint: "none",
			})}
		>
			{t(open ? "wageBreakdown.composition.hide" : "wageBreakdown.composition.show")}
		</SystemButton>
	);
};
